var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCalendarOutline(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 14 14",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#calendar-outline_svg__clip0_31_3094)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.917.725h-1.625V.187a.537.537 0 00-.542-.539.543.543 0 00-.542.539v.538H3.792V.187a.537.537 0 00-.542-.539.543.543 0 00-.542.539v.538H1.083C.796.725.52.84.317 1.041A1.074 1.074 0 000 1.802v10.77c0 .285.114.559.317.76.203.203.479.316.766.316h10.834c.287 0 .563-.113.766-.315.203-.202.317-.476.317-.762V1.802c0-.285-.114-.56-.317-.761a1.087 1.087 0 00-.766-.316zM2.708 1.802v.539a.537.537 0 00.542.538.543.543 0 00.542-.538v-.539h5.416v.539a.537.537 0 00.542.538.543.543 0 00.542-.538v-.539h1.625v2.154H1.083V1.802h1.625zm9.209 10.77H1.083v-7.54h10.834v7.54z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "calendar-outline_svg__clip0_31_3094"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h14v14H0z"
  })))));
}
export default SvgCalendarOutline;